import LocalizedStrings from "react-localization";
import en from "./en";
import sv from "./sv";

let Localization = new LocalizedStrings({ en, sv });
const lang = navigator.language.slice(0, 2);

Localization.setLanguage(lang);

export default Localization;
